import { appendAuthToken } from "../../config/formAuth";
import React, { useEffect, useRef, useMemo, useCallback } from 'react';
import { withRouter } from 'react-router-dom';

import Axios from '../../config/axios';
import Globals from '../../config/globals';

import Moment from 'moment';
import $ from 'jquery';

import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
import ReactLoading from 'react-loading';
import { Fragment } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import AddPatientPane from './AddPatientPane';
import PatientSearchForm from './PatientSearchForm';

import { Empty, message, Table, Collapse, Pagination } from 'antd';

import { loadingPatientResults, patientResults, getPatientInformationByIDNew, downloadPatientList, allCategories } from '../../common/services/ApiService';
import { takeWhile } from 'rxjs/operators';

import { toast } from '@rickylandino/react-messages';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

import NumberFormat from 'react-number-format';
import { handlePrintHx } from '../../common/services/ReportService';
import { useState } from 'react';

import { useRecoilState } from 'recoil';
import { useMediaQuery } from 'react-responsive';
import { loadingSearchResults, patientFilterString, patientTableParams } from '../../common/services/PatientService';

import { fetcher } from '../../common/swr/fetcher';
import useSWR, { useSWRConfig } from 'swr';
import MwlAdder from './MwlAdder';

function PatientsHome(props) {
    const { mutate } = useSWRConfig();

    const _isMounted = useRef(true);

    let userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));

    const [state, setState] = useState({
        patients: [],
        selectedPatient: null,
        insuranceCompany: null,
        loading: true,
        loadPatient: true,
        facilitySelected: false,
        selectedFacility: {},
        formFields: {
            modality: ''
        },
        showAddPatient: false,
        showCustomColumns: false,
        initialSearch: true
    });

    const [patientList, setPatientList] = useState([]);
    const [noPatients, setNoPatients] = useState(true);
    const [hasNextPage, setHasNextPage] = useState(true);

    const [mwl, setMwl] = useState({
        isOpen: false,
        patientID: null,
        facilityID: null
    });

    const [allCategoriesState, setAllCategories] = useState([]);

    const [tableParams, setTableParams] = useRecoilState(patientTableParams);
    const [filterString, setFilterString] = useRecoilState(patientFilterString);

    const [loading, setLoading] = useRecoilState(loadingSearchResults);

    const [routing, setRouting] = useState(false);

    const isDesktop = useMediaQuery({ minWidth: 1200 });
    const [lastKey, setLastKey] = useState('');

    const key = useMemo(() => 
        `/api/GetPatients?userID=${userInfo.userId}&pageSize=${tableParams.pagination.pageSize}&offset=${tableParams.pagination.current - 1}${filterString ? filterString : ''}&searchType=quick`,
        [userInfo.userId, tableParams.pagination.pageSize, tableParams.pagination.current, filterString]
    );

    //This is used to invalidate swr query after a patient has been added
    const page1Key = useMemo(() =>
        `/api/GetPatients?userID=${userInfo.userId}&pageSize=${tableParams.pagination.pageSize}&offset=0${filterString ? filterString : ''}&searchType=quick`,
        [userInfo.userId, tableParams.pagination.pageSize, tableParams.pagination.current, filterString]
    );


    const { data, error, isLoading, isValidating } = useSWR(
        key,
        fetcher,
        {
            revalidateIfStale: true,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            dedupingInterval: 2000,
            shouldRetryOnError: false
        });

    useEffect(() => {
        if(tableParams.pagination.current !== 1) {
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    current: 1
                }
            });
        }
    }, []);

    useEffect(() => {
        const isFromSearch = props.location?.state?.from === 'search';
        const isFromPatientDashboard = props.location?.state?.from === 'patientDashboard';

        if (!isFromSearch && !isFromPatientDashboard) {
            setFilterString('');
        }
        // SWR revalidateIfStale:true handles background refresh on every navigation;
        // no need to block re-fetches — external API updates are picked up automatically.
        setLastKey(key);
    }, [props.location?.state?.from, key]);

    useEffect(() => {
        _isMounted.current = true;
        loadingPatientResults.next(true);

        $(document).ready();
        $(document.body).on('keydown', handleKeyDown);

        if (Globals.selectedFacility.facilityID) {
            setState({
                ...state,
                facilitySelected: true,
                selectedFacility: Globals.selectedFacility
            });
        }

        patientResults.pipe(takeWhile(() => _isMounted.current)).subscribe(data => {
            if (data?.length >= 0 || Globals.searchDirty) {
                setNoPatients(data?.length === 0);
                setPatientList(data);
                setLoading(false);

                setState({
                    ...state,
                    loading: false,
                    patients: data,
                    selectedPatient: data?.length > 0 ? data[0] : null
                });

                loadingPatientResults.next(false);
            }
        });

        loadingPatientResults.pipe(takeWhile(() => _isMounted.current)).subscribe(data => {
            setState({
                ...state,
                loading: data
            });
        });

        allCategories.pipe(takeWhile(() => _isMounted.current)).subscribe(data => {
            setAllCategories(data);
        });

        return () => {
            _isMounted.current = false;
            $(document.body).off('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        if (props.selectedFacility.facilityID !== state.selectedFacility.facilityID) {
            setState({
                ...state,
                loading: true
            });
        }
    }, [props.selectedFacility.facilityID]);

    useEffect(() => {
        if (Globals.selectedFacility.facilityID && (props.selectedFacility !== state.selectedFacility)) {
            setState({
                ...state,
                selectedFacility: props.selectedFacility,
                facilitySelected: true
            });
        }
    }, [props.selectedFacility]);

    useEffect(() => {
        if (data) {
            // Check if we have next page based on returned data length
            const hasMore = data.data && data.data.length === tableParams.pagination.pageSize;
            setHasNextPage(hasMore);

            // Update table params
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    showTotal: (total, range) => `Page ${tableParams.pagination.current}`
                }
            });

            patientResults.next(data.data || []);
            loadingPatientResults.next(false);
        }

        setLoading(false);
        setPatientList(data?.data || []);
        loadingPatientResults.next(false);
    }, [data, isLoading, isValidating]);

    // Custom pagination component
    const customPagination = {
        current: tableParams.pagination.current,
        pageSize: tableParams.pagination.pageSize,
        showSizeChanger: true,
        showQuickJumper: false,
        pageSizeOptions: ['25', '50', '100', '200'],
        showLessItems: true,
        total: hasNextPage ? (tableParams.pagination.current * tableParams.pagination.pageSize) + 1 : tableParams.pagination.current * tableParams.pagination.pageSize,
        itemRender: (current, type, originalElement) => {
            if (type === 'next') {
                if (!hasNextPage) {
                    return React.cloneElement(originalElement, {
                        className: `${originalElement.props.className} ant-pagination-disabled`,
                        style: {
                            cursor: 'not-allowed',
                            color: '#d9d9d9'
                        }
                    });
                }
                return originalElement;
            }
            if (type === 'prev') {
                return originalElement;
            }
            if (type === 'page') {
                return originalElement;
            }
            return originalElement;
        },
        onChange: (page, pageSize) => {
            // Prevent going to next page if no more data
            if (page > tableParams.pagination.current && !hasNextPage) {
                return;
            }

            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    current: page,
                    pageSize: pageSize
                }
            });
        },
        onShowSizeChange: (current, size) => {
            setTableParams({
                ...tableParams,
                pagination: {
                    ...tableParams.pagination,
                    current: 1,
                    pageSize: size
                }
            });
            setHasNextPage(true);
        }
    };

    function handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        setState({ ...state, formFields: { ...state.formFields, [name]: value } });
    }

    function handleKeyDown(event) {
        if (event.keyCode === 13 /*enter*/) {
            if (!event.target.offsetParent || !event.target.offsetParent === 'div.search-div.dropdown') {
                if (!routing) {
                    setRouting(true);
                    toast.loading('Loading Patient Information...', {key: 'loading'});
                    getPatientInformationByIDNew(state.selectedPatient.patientModel.patientID).then(data => {
                        props.history.push({
                            pathname: '/patient-dashboard',
                            state: { selectedObject: data.patientInformation, examInfo: data.examInfo, filteredCategoryList: state.selectedPatient.categoryList, facilityAccess: data.facilityAccess }
                        });
                        toast.destroy('loading');
                    });
                }
            }
        }
        if (event.keyCode === 40 /*down*/) {
            event.preventDefault();

            let i = patientList.findIndex(obj => obj.patientModel.patientID === state.selectedPatient.patientModel.patientID);
            let selectedPatient = patientList[i + 1]
            setState({
                ...state,
                selectedPatient
            });
        }

        if (event.keyCode === 38 /*up*/) {
            event.preventDefault();

            let i = patientList.findIndex(obj => obj.patientModel.patientID === state.selectedPatient.patientModel.patientID);
            if (i !== 0) {
                let selectedPatient = patientList[i - 1]
                setState({
                    ...state,
                    selectedPatient
                });
            }
        }
    }

    function updatePatientsLoading() {
        setState({
            ...state,
            loading: true
        });
    }

    async function updatePatients() {
        await setState({ ...state, loading: true });

        setPatientList(Globals.patients);
        setNoPatients(Globals.patients.length > 0 ? false : true);

        setState({
            ...state,
            patients: Globals.patients,
            loading: false,
            noPatients: Globals.patients.length > 0 ? false : true
        });
    }

    function handleBulkPrint() {
        const q = Axios.defaults.baseURL + "api/RenderPatientResults";

        var form = document.createElement("form");
        form.target = "_blank";
        form.method = "POST";
        form.action = q;
        form.style.display = "none";

        var input = document.createElement("input");
        input.type = "hidden";
        input.name = "patientResults";
        input.value = JSON.stringify(patientList);
        form.appendChild(input);

        appendAuthToken(form);
        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
    }

    function handlePatientExport() {
        const key = "loading";
        message.loading({ content: 'Exporting Patients...', key, duration: 0 });
        let fileName = "patient-results_" + Moment().format('YYYYMMDDHm') + '.xlsx';

        downloadPatientList(patientList, fileName).then(data => {
            const url = window.URL.createObjectURL(new Blob([data]));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = fileName;
            a.click();
            window.URL.revokeObjectURL(url);

            message.destroy(key);

            setState({
                ...state,
                downloading: false
            })
        }).catch(error => {
            console.log("Error");
        });
    }

    function fullNameFormatter(cell, row) {
        return (
            <span>{row.providerModel?.fName && row.providerModel.fName} {row.providerModel?.lName && row.providerModel.lName}</span>
        );
    }

    function checkboxFormatter(cell, row) {
        return (
            <div className="">
                <div className="custom-control custom-checkbox custom-control-inline">
                    {(cell === "Yes" || cell === "High") &&
                        <i className="fas fa-check fa-125x color-pink text-center"></i>
                    }
                </div>
            </div>
        );
    }

    function folderFormatter(cell, row) {
        return (
            <i id="openChart" className="far fa-folder-open fa-125x color-pink text-center"></i>
        );
    }

    const mwlFormatter = (cell, row, index) => {
        return (
            <button type="button" id="addToMWL" className="unstyleBtn ml-3" onClick={() => setMwl({ isOpen: true, patient: row.patientModel, facility: row.facilityModel, patientID: row.patientModel.patientID, facilityID: row.patientModel.facilityID })}>
                <i className="fas fa-share-alt fa-125x color-pink text-center" id="addToMWL"></i>
            </button>
        );
    }

    function hxFormatter(cell, row) {
        return (
            <i id="printHx" className="fas fa-file-medical fa-125x color-pink text-center"></i>
        );
    }

    const [patientColumns, setPatientColumns] = useState([
        {
            dataIndex: ['patientModel', 'mrn'],
            title: 'Patient ID',
            responsive: ['md']
        }, {
            dataIndex: ['patientModel', 'lName'],
            title: 'Last Name'
        }, {
            dataIndex: ['patientModel', 'fName'],
            title: 'First Name'
        }, {
            dataIndex: ['patientModel', 'dob'],
            title: 'DOB',
            render: cell => Moment(new Date(cell)).format('L'),
            responsive: ['xl']
        }, {
            dataIndex: ['facilityModel', 'facilityName'],
            title: 'Facility',
            responsive: ['xl']
        }, {
            dataIndex: ['patientModel', 'address1'],
            title: 'Address',
            responsive: ['xl']
        }, {
            dataIndex: ['providerModel', 'fName'],
            title: 'Referring MD',
            render: fullNameFormatter,
            responsive: ['xl']
        }, {
            dataIndex: ['insuranceModel', 'insCompName'],
            title: 'Insurance',
            responsive: ['xl']
        }, {
            dataIndex: ['patientModel', 'densityStatus'],
            title: 'Dense',
            render: checkboxFormatter,
            responsive: ['xl']
        }, {
            dataIndex: ['patientModel', 'riskStatus'],
            title: 'High Risk',
            render: checkboxFormatter,
            responsive: ['xl']
        }
    ]);

    const modifiedPatientColumns = [
        ...patientColumns.filter(c => !c.hide),
        {
            dataIndex: 'dum1',
            title: 'Open Chart',
            render: folderFormatter
        }, {
            dataIndex: 'd3',
            title: 'Print Hx',
            render: hxFormatter
        }, {
            dataIndex: 'dum2',
            title: 'Add to MWL',
            render: mwlFormatter
        }
    ];

    const newExpander = (row) => {
        return (
            <div>
                <div><strong>Name: </strong>{row.patientModel.fName} {row.patientModel.lName}</div>
                <div><strong>DOB: </strong>{row.patientModel.dob}</div>
                <div><strong>MRN #: </strong>{row.patientModel.mrn}</div>
                <div><strong>Address: </strong>{row.patientModel.address1}</div>
                <div><strong>Referring MD: </strong>{row.patientModel.primaryCarePhysician}</div>
            </div>
        );
    }

    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            pagination,
            filters,
            ...sorter,
        });
    };

    const { Panel } = Collapse;

    return (
        <div>
            {routing && <div style={{ "position": "fixed", "width": "100%", "height": "100%", "top": "0", "left": "0", "right": "0", "bottom": "0", "backgroundColor": "rgba(0,0,0,0.5)", "zIndex": "1001" }} />}
            <div className="row">
                <div className="col-lg-12" >
                    <div className="panel-hdr">
                        <h2>
                            Patients
                        </h2>

                        <button type="button" className="btn btn-submit margin-0-10" onClick={() => setState({ ...state, showAddPatient: true })} disabled={isValidating}>
                            New Patient
                        </button>
                    </div>

                    <div className="m-4">
                        <PatientSearchForm updatePatients={updatePatients} updatePatientsLoading={updatePatientsLoading} />
                    </div>

                    <Fragment>
                        {state.initialSearch ?
                            <div className="">
                                {(isLoading || isValidating) ?
                                    <span className="frame-heading"><ReactLoading className='tableLoading' type={"spokes"} color={'#F30079'} height={30} width={30} /> Loading ...</span>
                                    :
                                    <div>
                                        {noPatients ?
                                            <Empty
                                                image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                description={
                                                    <span>
                                                        No Patients Found
                                                    </span>
                                                }
                                            >
                                            </Empty>
                                            :
                                            <Fragment>
                                                <Table
                                                    rowKey={(record) => record.patientModel.patientID}
                                                    dataSource={patientList}
                                                    columns={modifiedPatientColumns}
                                                    rowClassName={record => record.patientModel.inactiveYN === '1' ? 'user-inactive' : '' }
                                                    size='small'
                                                    onRow={(row, rowIndex) => {
                                                        return {
                                                            onClick: e => {
                                                                if (e.target.tagName === 'I' && e.target.id === 'openChart') {
                                                                    if (!routing) {
                                                                        setRouting(true);
                                                                        toast.loading('Loading Patient Information...', { key: 'loading' });
                                                                        getPatientInformationByIDNew(row.patientModel.patientID).then(data => {
                                                                            setState({
                                                                                ...state,
                                                                                selectedPatient: data.patientInformation
                                                                            });

                                                                            props.history.push({
                                                                                pathname: '/patient-dashboard',
                                                                                state: { selectedObject: data.patientInformation, examInfo: data.examInfo, filteredCategoryList: row.categoryList, patientEthnicity: data.patientEthnicity, facilityAccess: data.facilityAccess }
                                                                            });
                                                                            toast.destroy('loading');
                                                                        });
                                                                    }
                                                                }
                                                                else if (e.target.tagName === 'I' && e.target.id === 'printHx') {
                                                                    handlePrintHx(row.patientModel.patientID);
                                                                }
                                                            },
                                                            onDoubleClick: e => {
                                                                if (!routing) {
                                                                    setRouting(true);
                                                                    toast.loading('Loading Patient Information...', { key: 'loading' });
                                                                    getPatientInformationByIDNew(row.patientModel.patientID).then(data => {
                                                                        setState({
                                                                            ...state,
                                                                            selectedPatient: data.patientInformation
                                                                        });

                                                                        props.history.push({
                                                                            pathname: '/patient-dashboard',
                                                                            state: { selectedObject: data.patientInformation, examInfo: data.examInfo, filteredCategoryList: row.categoryList, patientEthnicity: data.patientEthnicity, facilityAccess: data.facilityAccess }
                                                                        });
                                                                        toast.destroy('loading');
                                                                    });
                                                                }
                                                            },
                                                            onContextMenu: event => { },
                                                            onMouseEnter: event => { },
                                                            onMouseLeave: event => { },
                                                        };
                                                    }}
                                                    expandable={!isDesktop && {
                                                        expandedRowRender: (record) => newExpander(record),
                                                        rowExpandable: (record) => record.patientModel.patientID !== 'Not Expandable',
                                                    }}

                                                    onChange={handleTableChange}
                                                    pagination={customPagination}
                                                />
                                            </Fragment>
                                        }
                                    </div>
                                }
                            </div>
                            :
                            <h2 className="ml-3 mt-3">Begin by searching for a patient</h2>
                        }
                    </Fragment>
                </div>
            </div>
            {state.showAddPatient && <AddPatientPane showPane={state.showAddPatient} hidePane={() => setState({ ...state, showAddPatient: false })} mutate={mutate} patientsKey={page1Key} />}
            <MwlAdder info={mwl} allCategories={allCategoriesState} close={() => setMwl({ isOpen: false, patientID: null, facilityID: null })} />
        </div>
    );
}

export default withRouter(PatientsHome);
